import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Container,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Avatar,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const ManagerLayout = ({ children }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState("");
  const [logoutAnchorEl, setLogoutAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const open = Boolean(anchorEl);
  const logoutMenuOpen = Boolean(logoutAnchorEl);
  const user = JSON.parse(localStorage.getItem("user"));

  const handleMenuOpen = (e, menuName) => {
    setAnchorEl(e.currentTarget);
    setOpenMenu(menuName);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setOpenMenu("");
  };

  const handleLogoutMenuOpen = (event) => {
    setLogoutAnchorEl(event.currentTarget);
  };

  const handleLogoutMenuClose = () => {
    setLogoutAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    setLogoutAnchorEl(null);
    navigate("/");
  };

  const handleNavigate = (path) => {
    navigate(path);
    handleMenuClose();
    setDrawerOpen(false);
  };

  const drawerItems = [
    { label: "Production", path: "/manager/production/view" },
    { label: "Attendance", path: "/manager/attendance" },
  ];

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <AppBar position="fixed" color="primary">
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box display="flex" alignItems="center">
            {isMobile && (
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => setDrawerOpen(true)}
                sx={{ mr: 1 }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <Typography variant="h6" noWrap>
              Rupioo DMS
            </Typography>
          </Box>

          {!isMobile && (
            <Box sx={{ display: "flex", gap: 2 }}>
              {/* <Button
                color="inherit"
                onClick={(e) => handleMenuOpen(e, "create")}
              >
                Create
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={openMenu === "create"}
                onClose={handleMenuClose}
              >
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/customers")}
                >
                  Customer
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/product")}
                >
                  Product
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/unit/view")}
                >
                  Unit
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/user/view")}
                >
                  User
                </MenuItem>
              </Menu> */}
              <Button
                color="inherit"
                onClick={() => handleNavigate("/manager/production/view")}
              >
                Production
              </Button>
              <Button
                color="inherit"
                onClick={() => handleNavigate("/manager/attendance")}
              >
                Attendance
              </Button>
            </Box>
          )}

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton onClick={handleLogoutMenuOpen}>
              <Avatar sx={{ width: 32, height: 32, mr: 1 }} />
              <Typography variant="body1">{user?.name || "Manager"}</Typography>
            </IconButton>
            <Menu
              anchorEl={logoutAnchorEl}
              open={logoutMenuOpen}
              onClose={handleLogoutMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer for Mobile */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 240 }} role="presentation">
          <List>
            {drawerItems.map((item, idx) => (
              <ListItem
                button
                key={idx}
                onClick={() => handleNavigate(item.path)}
              >
                <ListItemText primary={item.label} />
              </ListItem>
            ))}
            <ListItem button onClick={handleLogout}>
              <ListItemText primary="Logout" />
            </ListItem>
          </List>
        </Box>
      </Drawer>

      {/* Main Content */}
      <Box
        component="main"
        flexGrow={1}
        sx={{ mt: 8, mb: 8, overflowY: "auto" }}
      >
        <Container maxWidth="screen">{children}</Container>
      </Box>

      {/* Footer */}
      <Box
        component="footer"
        sx={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          height: "64px",
          bgcolor: "primary.main",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="body2">
          © {new Date().getFullYear()} DMS
        </Typography>
      </Box>
    </Box>
  );
};

export default ManagerLayout;
